import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from 'next/router'
import { getPage } from "../../adapters/contentful.adapters"
import { getStores } from "../../adapters/sdc.adapters"
import storeLocatorQuery from "./StoreLocator.query"
import storeLocatorQuery1 from "./StoreLocator.query.1"
import PGdataLayer from '../../components/PGDataLayer/PGDataLayer'
import { contentType, headerStyle } from '../../constants/global'
import ChinaStoreLocator from "../../components/ChinaStoreLocator"
import PageMetadata from "../../components/PageMetadata"

class HomepageContainer extends Component {
    static propTypes = {
        data: PropTypes.oneOfType([PropTypes.object]).isRequired,
        router: PropTypes.oneOfType([PropTypes.object]).isRequired,
    }

    static async getInitialProps({ query }) {
        try {
            const storeLocatorData = await getPage(
                "storeLocatorCollection",
                storeLocatorQuery
            )
            const storeLocatorData1 = await getPage(
                "storeLocatorCollection",
                storeLocatorQuery1
            )
            if (!storeLocatorData.disableLiveStoreData) {
                const liveStoresData = await getStores()
                if (liveStoresData) {
                    if (process.env.SITE_LOCALE == 'zh-TW') {
                        let newData = storeLocatorData.additionalStoreData
                        liveStoresData.forEach((content, index) => {
                            return newData.map((periodData) => {
                                if (content.code == periodData.code) {
                                    content['kcpPeriod'] = periodData.kcpPeriod
                                    liveStoresData[index] = content
                                }
                            })
                        })
                    }
                    storeLocatorData.storeData.store = liveStoresData
                }
            }
            return { data: { ...storeLocatorData, ...storeLocatorData1 }, pageContext: query, template: contentType.storeLocatorPage, header: headerStyle.bgWhite }
        } catch (err) {
            console.error("Error", JSON.stringify(err))
        }
    }

    storelocAddClass = () => {
        document.querySelector("html").classList.add("storeloc")
    }

    render() {
        typeof window !== "undefined" && this.storelocAddClass()
        const { data, router } = this.props
        return (
            <React.Fragment>
                {/* <Interstitial /> */}
                <PGdataLayer
                    locale={process.env.SITE_LOCALE}
                    pageType={contentType.storeLocatorPage}
                    path={decodeURI(router.asPath)}
                    title={data && data.pageMetadata
                        &&
                        data.pageMetadata
                            .metaTitle}
                />
                <PageMetadata
                    data={data && data.pageMetadata}
                    path={router && router.asPath}
                />
                <ChinaStoreLocator apiKey={process.env.BAIDU_MAP_KEY} storeData={data} />
            </React.Fragment>
        )
    }
}
export default withRouter(HomepageContainer)
